<template>
  <li class="octadesk-chat-ticket-label">
    <span>
      <svg viewBox="0 0 1024 1024" width="14" height="14">
        <use xlink:href="#octadesk-app-icon-ticket"></use>
      </svg>
      {{ $t('conversation.ticket') }} {{ value }}
    </span>
  </li>
</template>

<script>
  export default {
    props: ['value']
  }
</script>

<style></style>
